import { styled } from "@mui/system";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { Divider, Box } from "@mui/material";

import { useEffect, useState } from "react";
import { useFetchTeamInfoQuery } from "../../store/api/infoApi";
import LoadingSpinner from "../../components/LoadingSpinner";
import UpdateFinancialInfo from "./EditFinancialInfoDialog";
import SuccessSnackbar from "../../components/Snackbar";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: "auto",
  maxWidth: 600,
  position: "relative",
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  textAlign: "left",
  marginBottom: theme.spacing(2),
  color: "blue",
}));

const EditButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(1),
  right: theme.spacing(1),
}));

const FinancialInformation = () => {
  const { isLoading: isTeamInfoFetchLoading, isSuccess: isTeamInfoFetchSuccess, data: teamDetails, refetch: refetchTeamDetails } = useFetchTeamInfoQuery();

  const [showUpdateFinancialInfoDialog, setShowUpdateFinancialInfoDialog] = useState(false);
  const [showSuccessbar, setShowSucessbar] = useState(false);

  const handleUpdateFinanciald = () => {
    setShowUpdateFinancialInfoDialog(true);
  };

  const handleCloseUpdateFinancialInfoDialog = () => {
    setShowUpdateFinancialInfoDialog(false);
  };

  const openSuccessbar = () => {
    setShowSucessbar(true);
  };

  const closeSuccessbar = () => {
    setShowSucessbar(false);
  };

  useEffect(() => {
    refetchTeamDetails();
  }, []);

  if (isTeamInfoFetchLoading) return <LoadingSpinner />;
  else if (isTeamInfoFetchSuccess && teamDetails)
    return (
      <StyledPaper>
        <TitleTypography variant="h5">Financial Info</TitleTypography>
        <EditButton>
          <EditIcon onClick={handleUpdateFinanciald} />
        </EditButton>
        <SuccessSnackbar open={showSuccessbar} handleClose={closeSuccessbar} width="30vw" severity="success" message="Financial info updated" />

        <Box marginBottom={2} marginTop={2}>
          <Typography>Number of Employees: {teamDetails?.data?.financial_info?.number_of_employee}</Typography>
        </Box>

        <Divider />
        <Box marginBottom={2} marginTop={2}>
          <Typography>Financial Turnover Year: {teamDetails?.data?.financial_info?.year}</Typography>
        </Box>

        <Divider />
        <Box marginBottom={2} marginTop={2}>
          <Typography>
            Financial Turnover Amount:{" "}
            {new Intl.NumberFormat("de-DE", { style: "currency", currency: "GBP" }).format(teamDetails?.data?.financial_info?.turnover_amount)}
          </Typography>
        </Box>

        <Divider />

        {showUpdateFinancialInfoDialog && (
          <UpdateFinancialInfo openDialog={showUpdateFinancialInfoDialog} handleCloseDialog={handleCloseUpdateFinancialInfoDialog} onSuccess={openSuccessbar} />
        )}
      </StyledPaper>
    );
  else return <div>Error fetching user information</div>;
};

export default FinancialInformation;
